import React from "react";
import styled from "styled-components";

import classes from "./styles.module.css";
import { experienceData, projectData, educationData, certificateData } from "../../helpers/constant";
import { FaTrash } from "react-icons/fa";
import { ImagePicker } from "../helpers/ImagePicker";

const NewStaticTemplate = (props) => (
    <Body>
        <Container>
            <main className={`${classes["main-description"]} ${classes["column"]}`}>
                <div>
                    <h2 className={classes.item}>About me</h2>
                    <p
                        contentEditable='true'
                        suppressContentEditableWarning='true'
                        onBlur={e => props.setNormalValueToState("aboutMe", e.currentTarget.textContent)}
                        className={`${classes["justify"]} ${classes["fs-12"]} ${classes["item"]}`}>
                        {props.state.aboutMe}
                    </p>
                </div>

                <div>
                    <h2 className={classes.item}>Experience</h2>
                    <div className={classes.column}>
                        {props.state.experience.map((item, index) =>
                            <div className={`${classes["row"]} ${classes["item"]} ${classes["justify-sb"]}`}>
                                <div className={`${classes["column"]} ${classes["job-description"]}`}>
                                    <span
                                        className={classes.title}
                                        contentEditable='true'
                                        suppressContentEditableWarning='true'
                                        onBlur={e => props.setArrayOfObjectToState("experience", index, "company", e.currentTarget.textContent)}
                                    >{item.company}</span>
                                    <span
                                        className={classes["sub-title"]}
                                        contentEditable='true'
                                        suppressContentEditableWarning='true'
                                        onBlur={e => props.setArrayOfObjectToState("experience", index, "position", e.currentTarget.textContent)}
                                    >{item.position}</span>
                                    <p
                                        className={`${classes["justify"]} ${classes["fs-12"]} ${classes["mar-top-8"]} ${classes.heighlight}`}
                                        contentEditable='true'
                                        suppressContentEditableWarning='true'
                                        onBlur={e => props.setArrayOfObjectToState("experience", index, "jobDescription", e.currentTarget.textContent)}
                                    >{item.jobDescription}</p>
                                </div>
                                <div className={`${classes["column"]} ${classes["job-time-wrapper"]}`}>
                                    <span
                                        className={classes["sub-title"]}
                                        contentEditable='true'
                                        suppressContentEditableWarning='true'
                                        onBlur={e => props.setArrayOfObjectToState("experience", index, "place", e.currentTarget.textContent)}
                                    >{item.place}</span>
                                    <span className={`${classes["job-duration"]} ${classes["fs-12"]} ${classes["mar-top-8"]}`}>
                                        <span
                                            className={`${classes["fs-12"]} ${classes.heighlight}`}
                                            contentEditable='true'
                                            suppressContentEditableWarning='true'
                                            onBlur={e => props.setArrayOfObjectToState("experience", index, "from", e.currentTarget.textContent)}
                                        >{item.from}
                                        </span> -
                                            <span
                                            className={`${classes["fs-12"]} ${classes.heighlight}`}
                                            contentEditable='true'
                                            suppressContentEditableWarning='true'
                                            onBlur={e => props.setArrayOfObjectToState("experience", index, "to", e.currentTarget.textContent)}
                                        >{item.to}
                                        </span>
                                    </span>
                                </div>
                                <FaTrash className="marRight-10" onClick={() => props.deleteFromArrayOfObject("experience", index)} />
                            </div>
                        )}
                        <button className="btn-circle-plus" onClick={() => props.addNewArrayOfObject("experience", JSON.parse(JSON.stringify(experienceData)))}>+</button>
                    </div>
                </div>

                <div>
                    <h2 className={classes.item}>Education</h2>
                    <div className={classes.column}>
                        {props.state.education.map((item, index) =>
                            <div className={`${classes.column} ${classes.item}`}>
                                <div className={classes.row}>
                                    <span
                                        className={classes.title}
                                        contentEditable='true'
                                        suppressContentEditableWarning='true'
                                        onBlur={e => props.setArrayOfObjectToState("education", index, "course", e.currentTarget.textContent)}
                                    >{item.course}</span>
                                    <FaTrash className="marLeft-10" onClick={() => props.deleteFromArrayOfObject("education", index)} />
                                </div>
                                <span
                                    contentEditable='true'
                                    suppressContentEditableWarning='true'
                                    onBlur={e => props.setArrayOfObjectToState("education", index, "time", e.currentTarget.textContent)}
                                    className={classes["sub-title"]}>{item.time}</span>
                                <p
                                    className={`${classes["justify"]} ${classes["fs-12"]} ${classes["mar-top-8"]} ${classes.heighlight}`}
                                    contentEditable='true'
                                    suppressContentEditableWarning='true'
                                    onBlur={e => props.setArrayOfObjectToState("education", index, "desc", e.currentTarget.textContent)}
                                >{item.desc}</p>
                            </div>
                        )}
                        <button className="btn-circle-plus" onClick={() => props.addNewArrayOfObject("education", JSON.parse(JSON.stringify(educationData)))}>+</button>
                    </div>
                </div>

                <div>
                    <h2 className={classes.item}>Projects</h2>
                    <div className={classes.column}>
                        {props.state.project.map((item, index) =>
                            <div className={`${classes.column} ${classes.item}`}>
                                <div className={classes.row}>
                                    <span
                                        contentEditable='true'
                                        suppressContentEditableWarning='true'
                                        onBlur={e => props.setArrayOfObjectToState("project", index, "name", e.currentTarget.textContent)}
                                        className={classes.title}>{item.name}</span>
                                    <FaTrash className="marLeft-10" onClick={() => props.deleteFromArrayOfObject("project", index)} />
                                </div>
                                <p
                                    contentEditable='true'
                                    suppressContentEditableWarning='true'
                                    onBlur={e => props.setArrayOfObjectToState("project", index, "desc", e.currentTarget.textContent)}
                                    className={`${classes["justify"]} ${classes["fs-12"]} ${classes["mar-top-8"]} ${classes.heighlight}`}>{item.desc}</p>
                            </div>
                        )}
                        <button className="btn-circle-plus" onClick={() => props.addNewArrayOfObject("project", JSON.parse(JSON.stringify(projectData)))}>+</button>
                    </div>
                </div>

                <div>
                    <h2 className={classes.item}>Certificates</h2>
                    <div className={classes.column}>
                        {props.state.certificate.map((item, index) =>
                            <div className={`${classes.column} ${classes.item}`}>
                                <div className={classes.row}>
                                    <span
                                        contentEditable='true'
                                        suppressContentEditableWarning='true'
                                        onBlur={e => props.setArrayOfObjectToState("certificate", index, "name", e.currentTarget.textContent)}
                                        className={classes.title}>{item.name}</span>
                                    <FaTrash className="marLeft-10" onClick={() => props.deleteFromArrayOfObject("certificate", index)} />
                                </div>
                                <p
                                    contentEditable='true'
                                    suppressContentEditableWarning='true'
                                    onBlur={e => props.setArrayOfObjectToState("certificate", index, "provider", e.currentTarget.textContent)}
                                    className={`${classes["justify"]} ${classes["fs-12"]} ${classes["mar-top-8"]} ${classes.heighlight}`}>{item.provider}</p>
                            </div>
                        )}
                        <button className="btn-circle-plus" onClick={() => props.addNewArrayOfObject("certificate", JSON.parse(JSON.stringify(certificateData)))}>+</button>
                    </div>
                </div>
            </main>

            <main className={classes["main-personal"]}>
                <div className={classes["image-bio-container"]}>
                    <ImagePicker saveImage={props.setNormalValueToState} value={props.state.imageData} />
                    <h2 className={`${classes["mar-top-8"]} ${classes.heighlight}`}>
                        <span
                            contentEditable='true'
                            suppressContentEditableWarning='true'
                            className={classes.heighlight}
                            onBlur={e => props.setNormalValueToState("name", e.currentTarget.textContent)}
                        >
                            {props.state.name}
                        </span>
                        <span
                            contentEditable='true'
                            className={classes.heighlight}
                            suppressContentEditableWarning='true'
                            onBlur={e => props.setNormalValueToState("surname", e.currentTarget.textContent)}
                        >
                            {props.state.surname}
                        </span>
                    </h2>
                    <span
                        contentEditable='true'
                        suppressContentEditableWarning='true'
                        onBlur={e => props.setNormalValueToState("position", e.currentTarget.textContent)}
                        className={`${classes["mar-top-8"]} ${classes.heighlight}`}>{props.state.position}</span>
                    <span
                        contentEditable='true'
                        suppressContentEditableWarning='true'
                        className={classes.heighlight}
                        onBlur={e => props.setNormalValueToState("email", e.currentTarget.textContent)}
                    >{props.state.email}</span>
                </div>

                <div className={classes["mar-top-30"]}>
                    <div>
                        <h3>Skills</h3>
                        <div className="skillContainer">
                            {props.state.skills.map((item, index) =>
                                <div
                                    key={`skillItem_${index}`}
                                    contentEditable='true'
                                    suppressContentEditableWarning='true'
                                    onBlur={e => props.setArrayValueToState("skills", index, e.currentTarget.textContent)}
                                    className={classes.skillItem}>{item}</div>
                            )}
                            <button className="btn-circle-plus" onClick={() => props.addNewArrayValue("skills")}>+</button>
                        </div>
                    </div>
                    <div className={classes.item}>
                        <h3>Other Skills</h3>
                        <div className={`${classes["column"]} ${classes["mar-top-8"]}`}>
                            {props.state.otherSkills.map((item, index) =>
                                <span
                                    key={`otherSkills_${index}`}
                                    className={classes.heighlight}
                                    contentEditable='true'
                                    suppressContentEditableWarning='true'
                                    onBlur={e => props.setArrayValueToState("otherSkills", index, e.currentTarget.textContent)}
                                >{item}</span>
                            )}
                            <button className="btn-circle-plus" onClick={() => props.addNewArrayValue("otherSkills")}>+</button>
                        </div>
                    </div>
                    <div className={classes.item}>
                        <h3>Address</h3>
                        <span className={`${classes["column"]} ${classes["mar-top-8"]}`}>
                            <span
                                contentEditable='true'
                                suppressContentEditableWarning='true'
                                className={classes.heighlight}
                                onBlur={e => props.setObjectValueToState("address", "area", e.currentTarget.textContent)}
                            >{props.state.address.area}</span>
                            <span>
                                <span
                                    contentEditable='true'
                                    className={classes.heighlight}
                                    suppressContentEditableWarning='true'
                                    onBlur={e => props.setObjectValueToState("address", "city", e.currentTarget.textContent)}
                                >{props.state.address.city}</span> -<span
                                    contentEditable='true'
                                    className={classes.heighlight}
                                    suppressContentEditableWarning='true'
                                    onBlur={e => props.setObjectValueToState("address", "pin", e.currentTarget.textContent)}
                                >{props.state.address.pin}</span>
                            </span>
                            <span
                                contentEditable='true'
                                className={classes.heighlight}
                                suppressContentEditableWarning='true'
                                onBlur={e => props.setObjectValueToState("address", "country", e.currentTarget.textContent)}
                            >{props.state.address.country}</span>
                        </span>
                    </div>
                </div>
            </main>
        </Container>
    </Body >
);

const Body = styled.div`
    margin: 0;
    box-shadow: 0px 1px 3px 0px rgba(163,143,163,1);
    background-color:white;
    margin-bottom:80px;
`;

const Container = styled.div`
    display:flex;
`;

export default NewStaticTemplate;